import { Text } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatTableTopX } from 'src/utils/table';

import { useDashboardServicesStore } from '../../../../models/useDashboardServicesModel';
import { ThreatType } from '../../../../utils/enums';
import { getServiceNamesByValues } from '../../../../utils/service';
import { generateRedirectUrlToLog } from '../../../Log/shared';
import TableTemplate from '../../Charts/TableTemplate';
import DashboardCard from '../../Layout/DashboardCard';
import RedirectLink from '@Components/RedirectLink';
import { LogTypeEnum, SecurityFilterName } from '@Types/log';

function DlpTemplates(props: { data: any; day: string }) {
  const { t } = useTranslation();
  const servicesModel = useDashboardServicesStore();
  const config = [
    { width: '50%', grow: 1, align: 'left', tooltip: true },
    { width: '30%', grow: 0, align: 'right' },
  ];
  const header = [
    t('dashboard.chart.column.templateName'),
    t('dashboard.chart.column.occurrences'),
  ];

  if (!props.data) {
    return (
      <DashboardCard title={t('dashboard.chart.title.dlpTemplates')}>
        <TableTemplate config={config} header={header} data={[]} />
      </DashboardCard>
    );
  }

  const translatedTemplates = props.data?.data_protectionCounts?.[
    props.day
  ]?.templates?.map((template: any) => {
    try {
      const _source = template.latest_hit?.hits?.hits[0]?._source;
      return {
        doc_count: template.doc_count,
        key: {
          rule: _source.tm_dlp_rule[0],
          template: _source.tm_dlp_template[0],
        },
      };
    } catch {
      return {
        doc_count: template.doc_count,
        key: {
          rule: template.key,
          template: template.key,
        },
      };
    }
  });

  const data = formatTableTopX(
    translatedTemplates,
    ['key', 'doc_count'],
    t
  ).map((row) => [
    t(
      `dlp.ENTITY.${(row[0] as any).rule}.DISPLAYNAME`,
      (row[0] as any).template
    ),
    row[1] === 0 ? (
      0
    ) : (
      <RedirectLink
        href={`logs?${generateRedirectUrlToLog(
          [
            {
              field: 'threatType',
              values: [ThreatType.DLP],
              type: 'terms',
            },
            {
              field: 'dlpTemplate',
              values: [(row[0] as any).template],
              type: 'terms',
            },
            {
              field: 'securityFilterName',
              values: [SecurityFilterName.DLP],
              type: 'terms',
            },
            {
              field: 'scanSource',
              values: getServiceNamesByValues(servicesModel.enabledServices),
              type: 'terms',
            },
          ],
          props.day,
          LogTypeEnum.DETECTION
        )}`}
      >
        <Text>{row[1]}</Text>
      </RedirectLink>
    ),
  ]);

  return (
    <DashboardCard title={t('dashboard.chart.title.dlpTemplates')}>
      <TableTemplate config={config} header={header} data={data} />
    </DashboardCard>
  );
}

export default React.memo(DlpTemplates);
